.ad-wrapper {
  background-color: var(--palette-background-primary);
  margin: -15px 0;
  padding: 20px 0;
  transform: translateX(-1px);
  width: calc(100% + 1px);

  &::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='12'%3E%3Cpath fill='%23111' d='M3 0q.75 0 1.28.52.52.53.52 1.28t-.52 1.27Q3.75 3.6 3 3.6t-1.28-.53Q1.2 2.55 1.2 1.8T1.72.52Q2.25 0 3 0Zm.6 4.8v4.9l1.56-1.54L6 9l-3 3-3-3 .86-.84L2.4 9.71V4.8Z'/%3E%3C/svg%3E");
    background-position: left top;
    background-repeat: no-repeat;
    color: var(--palette-foreground-primary);
    content: "Czytaj dalej pod reklamą";
    display: block;
    font: use-font-secondary("700 14px/1");
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    text-align: left;
    width: max-content;
  }

  &:last-child::before {
    display: none;
  }
}